import MuiStep from '@material-ui/core/Step';
import MuiStepLabel from '@material-ui/core/StepLabel';
import MuiStepper from '@material-ui/core/Stepper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { HIGHLIGHT, TEXT } from '../Colors';
import { SUBTITLE } from '../Fonts';
import { Icon } from '../Icon';
import { STEPPER_COMPLETED_STEP } from '../Svgs';

const StyledMuiStepper = withStyles({
    root: {
        backgroundColor: 'unset'
    }
})(MuiStepper);

const StyledMuiStep = withStyles({
    root: {
        '& .MuiStepIcon-root': {
            color: '#929BA2'
        },
        '& .MuiStepIcon-active': {
            color: HIGHLIGHT
        },
        '& .MuiStepIcon-completed': {
            color: HIGHLIGHT
        },
        '& .MuiStepConnector-root > .MuiStepConnector-line': {
            borderColor: 'white'
        },
        '& .MuiStepConnector-root.Mui-disabled > .MuiStepConnector-line': {
            borderColor: '#929BA2'
        }
    }
})(MuiStep);

const StyledMuiStepLabel = withStyles({
    root: {
        font: SUBTITLE,
        '& .MuiStepIcon-text': {
            font: SUBTITLE,
            color: TEXT
        },
        '& .MuiStepLabel-label': {
            font: SUBTITLE,
            color: TEXT,
            marginTop: '8px'
        }
    }
})(MuiStepLabel);

const useStyles = makeStyles({
    hidden: {
        display: 'none',
    }
});

const CompletedIcon: React.FunctionComponent = () => {
    return (<Icon width="24px" height="24px">{STEPPER_COMPLETED_STEP}</Icon>);
}

interface StepperProps {
    selectedStep: number,
    steps: Array<string>,
    hidden?: boolean
}

export const Stepper: React.FunctionComponent<StepperProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const steps = props.steps.map((s, i) => <StyledMuiStep key={i}>
        <StyledMuiStepLabel StepIconComponent={i <= props.selectedStep ? CompletedIcon : null}>{s}</StyledMuiStepLabel>
    </StyledMuiStep>);

    const className = `${props.hidden ? classes.hidden : ''} ${stylingClassName}`

    return (
        <StyledMuiStepper className={className} alternativeLabel activeStep={props.selectedStep} hidden={props.hidden}>
            {steps}
        </StyledMuiStepper>
    );
}